module.exports = __webpack_public_path__ + "static/media/hualian_pic2.e2110b93.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/hualian_pic2.jpg
 ** module id = 445
 ** module chunks = 0
 **/